import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Sourcing from '@/views/Sourcing.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/sourcing',
        name: 'Sourcing',
        component: Sourcing
    },
    {
        path: '/print-on-demand',
        name: 'PrintOnDemand',
        component: () => import('@/views/PrintOnDemand.vue')
    },
    {
        path: '/wholesale',
        name: 'Wholesale',
        component: () => import('@/views/Wholesale.vue')
    },
    {
        path: '/why',
        name: 'WhyVN',
        component: () => import('@/views/WhyVN.vue')
    },
    {
        path: '/blog',
        name: 'VNBlogs',
        component: () => import('@/views/VNBlogs.vue')
    },
    {
        path: '/about-us',
        name: 'AboutUs',
        component: () => import('@/views/AboutUs.vue')
    },
    {
        path: '/shipping-policy',
        name: 'ShippingPolicyPage',
        component: () => import('@/views/ShippingPolicy.vue')
    },
    {
        path: '/terms-conditions',
        name: 'TermsAndConditions',
        component: () => import('@/views/TermsAndConditions.vue')
    },
    {
        path: '/refund-policy',
        name: 'RefundPolicy',
        component: () => import('@/views/RefundPolicy.vue')
    },
    {
        path: '/private-policy',
        name: 'PrivatePolicy',
        component: () => import('@/views/PrivatePolicy.vue')
    },
    {
        path: '/faq',
        name: 'FAQ',
        component: () => import('@/views/FAQ.vue')
    },
    {
        path: '/blog-info',
        name: 'BlogDetail',
        component: () => import('@/views/BlogDetail.vue')
    },
    {
        path: '/chery',
        name: 'Chery',
        component: () => import('@/views/Chery.vue')
    },
    {
        path: '/chery-mobile',
        name: 'CheryMobile',
        component: () => import('@/views/CheryMobile.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
